import Component from "./top-directors-films"
export default Component
